import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchOlaMapsLocationByLatLongType } from "../../../domain/models/ola-maps/fetch-ola-maps-location-by-lat-long";
import { FetchOlaMapsLocationByLatLong } from "../../../domain/useages/ola-maps/fetch-ola-maps-location-by-lat-long";
import { RemoteFetchOlaMapsLocationByLatLong } from "../../../data/usecases/ola-maps/remote-fetch-ola-maps-location-by-lat-long";

export interface FetchOlaMapsLocationByLatLongInterface {
    FetchOlaMapsLocationByLatLong: FetchOlaMapsLocationByLatLongType;
    FetchOlMapsLocationByLatLongState: FetchState;
    fetchOlaMapsLocationByLatLong: Function;
}

const initialStates = {
  FetchOlaMapsLocationByLatLong: {} as FetchOlaMapsLocationByLatLongType,
  FetchOlMapsLocationByLatLongState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchOlaMapsLocationByLatLongSlice: StateCreator<
  FetchOlaMapsLocationByLatLongInterface
> = (set) => ({
  ...initialStates,
  fetchOlaMapsLocationByLatLong: async (
    filter: FetchOlaMapsLocationByLatLong.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchOlaMapsLocationByLatLong =
      new RemoteFetchOlaMapsLocationByLatLong(
        `${BASE_URL}${Endpoints.FETCH_OLA_MAPS_LOCATION_BY_LAT_LONG}`,

        axiosHttpClient
      );

    set(() => ({ FetchOlMapsLocationByLatLongState: FetchState.LOADING }));
    let result = await remoteFetchOlaMapsLocationByLatLong.fetch(filter);
    return result;
  },
});
